<p-panel header="{{ 'fs.res.common.researchInfrastructures' | hisUi }}">
    <!-- #anchor dynamic field container -->    
    <ng-template #dynamicFieldContainer></ng-template>
    
    <div *ngIf="infoMessage" class="infoMessage">
        {{infoMessage}}
        <br>
    </div>
    <div class="selectAndTableCombination"> 
	    <his-plam [showLabelTop]="true">
	       <p-autoComplete #content
                [disabled]="!editMode"
                [hisDdKey]="dDKey"
                [(ngModel)]="selectedInfrastructure"
                hisLazyDataSource="api/v1/fs/res/researchInfrastructure/simple"
                field="title" 
                [minLength]="1"
                [forceSelection]="true"
                class="autocompleteWidth100" 
                (onSelect)="onSelectByAutocomplete()">
            </p-autoComplete>
            
            <his-search-select-popup
                [editMode]="editMode"
                searchConfigFile="{{SEARCH_CONFIG_INFRASTRUCTURE}}"
                [selectedOptions]="getSelectedInfrastructures()"
                selectedOptionsIdColumn="ResearchInfrastructure.id"
                [showDeleteButton]="false"
                (selectedOptionsChange)="onSelectBySearchPopup($event)">
            </his-search-select-popup>
	    </his-plam>
    
	    <div *ngIf="getSelectedInfrastructures()?.length > 0">
            <div class="clearAndSpace"></div>
            <p-table [value]="getSelectedInfrastructures()">
                <ng-template pTemplate="header">
                    <tr>
                        <th class="header-no-wrap" [pSortableColumn]="'title'">{{'fs.res.researchInfrastructure.ResearchInfrastructure.title' | hisUi}}
                            <p-sortIcon *ngIf="getSelectedInfrastructures().length > 1" [field]="'title'"></p-sortIcon>
                        </th>
                        <th class="header-no-wrap" [pSortableColumn]="'operator.researchPartner'">{{'fs.res.researchInfrastructure.ResearchInfrastructure.operator' | hisUi}}
                            <p-sortIcon *ngIf="getSelectedInfrastructures().length > 1" [field]="'operator'"></p-sortIcon>
                        </th>
                        <th class="header-no-wrap" [pSortableColumn]="'researchInfrastructureType.text'">{{'fs.res.researchInfrastructure.ResearchInfrastructure.researchInfrastructureType' | hisUi}}
                            <p-sortIcon *ngIf="getSelectedInfrastructures().length > 1" [field]="'researchInfrastructureType.text'"></p-sortIcon>
                        </th>
                        <th class="header-no-wrap" [pSortableColumn]="'researchInfrastructureKind.text'">{{'fs.res.researchInfrastructure.ResearchInfrastructure.researchInfrastructureKind' | hisUi}}
                            <p-sortIcon *ngIf="getSelectedInfrastructures().length > 1" [field]="'researchInfrastructureKind.text'"></p-sortIcon>
                        </th>                        
                        <th>{{'common.actions' | hisUi }}</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-index="rowIndex" let-infrastructure>
                    <tr>
                        <td>{{infrastructure.title}}</td>
                        <td>{{getOperatorsAsString(infrastructure)}}</td>
                        <td>{{infrastructure.researchInfrastructureType.text}}</td>
                        <td>{{infrastructure.researchInfrastructureKind.text}}</td>
                        
                        <td class="singleLine">
                            <a *ngIf="showInfrastructureViewBtn" (click)="onNavigate()" [routerLink]="['/researchInfrastructure/view/' + infrastructure.id]" [queryParams]="{showBackButton: true, showEditButton: false, showSearchButton: false}" hisImage="MAGNIFIER_DETAIL" [title]="'de.his.javang.show' | hisUi"></a>
                            <button (click)="removeInfrastructure(infrastructure)" hisImage="DELETE" [disabled]="!editMode" class="icon" 
                                title="{{'common.removeAssignmentOf' | hisUi:(infrastructure.title)}}"></button>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>    
    </div>
  
    <!-- #anchor dynamic field container -->    
    <ng-template #dynamicFieldContainer></ng-template>
    
</p-panel>